import { render, staticRenderFns } from "./ConfirmProduct.vue?vue&type=template&id=60ac0692"
import script from "./ConfirmProduct.vue?vue&type=script&lang=js"
export * from "./ConfirmProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports